import angular from 'angular';

angular.module('webTools').service('Profiles', ['$q', '$http',
	function($q, $http) {
	    return {
	        getProfileList: function(folderId) {

	            var defer = $q.defer();

	            $http.get('/api/profiles/getprofilelist', { params: { 'folderId': folderId } })
                .then(function(data) {
                    defer.resolve(data);
                })

	            return defer.promise;
	        },

	        getProperties: function(folderId, profileId) {

	            var defer = $q.defer();

	            $http.get('/api/profiles/getproperties', { params: { 'folderId': folderId, 'profileName': profileId } })
                .then(function(data) {
                    defer.resolve(data);
                })

	            return defer.promise;
	        }
	    }
	}
]);